export interface PasswordFormState {
  password: {
    value: string,
    error: {
      show: boolean,
      message: string
    }
  };
  confirmPassword: {
    value: string,
    error: {
      show: boolean,
      message: string;
    }
  };
  error: boolean;
};

export const initialPasswordFormState: PasswordFormState = {
  password: {
    value: '',
    error: {
      show: false,
      message: ''
    }
  },
  confirmPassword: {
    value: '',
    error: {
      show: false,
      message: ''
    }
  },
  error: false
};
